export const IN_SESSION_ASSESSMENT_SUGGESTIONS = [
  {
    assessmentName: 'DASS-21',
    rationale:
      `The DASS-21 can provide a broader understanding of the client's emotional state, including depression, anxiety, and stress levels.This is relevant given the client's reported symptoms and the focus on improving mood and reducing depressive symptoms.`,
    assessmentId: 'demo-assessment-id-1',
    contentSuggestionId: 'demo-content-suggestion-id-1',
    feedback: {},
    nQuestions: 21,
    condition: 'depression, stress, anxiety',
    cadenceUnit: 'weeks',
    cadenceValue: 1,
    clinicAssessmentId: 'clinic-demo-content-suggestion-id-1'
  },
  {
    assessmentName: 'ODSIS',
    rationale:
      `The ODSIS is a comprehensive assessment tool that evaluates both the severity of depressive symptoms and the level of associated impairment in daily functioning.
        Given the client's reported symptoms of depression and anxiety, this assessment will help to quantify the impact of these issues on the client's overall quality of life.`,
    assessmentId: 'demo-assessment-id-2',
    contentSuggestionId: 'demo-content-suggestion-id-2',
    feedback: {},
    nQuestions: 5,
    condition: 'depression',
    cadenceUnit: 'weeks',
    cadenceValue: 1,
    clinicAssessmentId: 'clinic-demo-content-suggestion-id-2'
  }
]

export const IN_SESSION_WORKSHEET_SUGGESTIONS = [
  {
    worksheetName: 'CBT Thought Record',
    rationale:
      'This worksheet will help the client understand how their thoughts and feelings about situations impact their mood. It aligns with the Cognitive Restructuring intervention being used to challenge and replace negative thought patterns, which is a key component of the treatment plan.',
    checkInId: 'demo-check-in-id-1',
    contentSuggestionId: 'demo-content-suggestion-id-1',
    feedback: {}
  },
  {
    worksheetName: 'Behavior Activation Tracking',
    rationale:
      'This worksheet will assist the client in tracking their behaviors and moods, helping them understand the connection between their actions and emotional states. It supports the Behavioral Experimentation and Pleasurable Activities Scheduling interventions by providing a structured way to monitor changes in mood related to specific activities.',
    checkInId: 'demo-check-in-id-2',
    contentSuggestionId: 'demo-content-suggestion-id-2',
    feedback: {}
  }
]

export const SESSION_PREP = {
  lastSessionRecap: [
    "You discussed the client's feelings of low energy and difficulty with daily tasks.",
    'You introduced CBT techniques: Behavioral Experimentation, Graded Task Assignment, Pleasurable Activities Scheduling, and Cognitive Restructuring.',
    'Client talked about feeling isolated and having trouble concentrating at work.',
    'You worked on this treatment goal: Client will improve mood and reduce depressive symptoms by engaging in pleasurable activities and completing behavioral experiments.'
  ],
  thisSessionFocusAreas: [
    "Review client's experience with making the bed as a behavioral experiment.",
    'Discuss any changes in mood or productivity from breaking down work tasks.',
    "Explore client's engagement with video gaming and its impact on mood."
  ],
  beforeYouBegin: {
    items: [
      {
        action: 'REVIEW_ASSESSMENT_RESULTS',
        data: {
          completedAssessment: {
            assessmentId: '6bdf26c0-e2d8-11e8-be06-fdb78b82093e',
            name: 'PHQ-9',
            score: 5,
            totalScore: 27
          }
        }
      },
      {
        action: 'REVIEW_WORKSHEET_RESULTS',
        data: {
          completedWorksheets: [{}, {}]
        }
      },
      {
        action: 'VIEW_ASSESSMENT_SUGGESTIONS',
        data: {
          suggestedAssessments: [{}, {}]
        }
      }
    ]
  }
}

export const POST_SESSION_ASSESSMENT_SUGGESTIONS = [
  {
    assessmentName: 'OASIS',
    rationale:
      `The OASIS is a well-structured self-report tool designed to assess the severity of anxiety and the extent of associated impairment in day-to-day functioning. For a client experiencing significant anxiety symptoms, the OASIS can provide valuable insights into how their anxiety affects various aspects of their life, including social, occupational, and personal domains.`,
    assessmentId: 'demo-assessment-id-3',
    contentSuggestionId: 'demo-content-suggestion-id-3',
    feedback: {},
    nQuestions: 5,
    condition: 'Anxiety',
    cadenceUnit: 'weeks',
    cadenceValue: 1,
    clinicAssessmentId: 'clinic-demo-content-suggestion-id-3'
  },
  ...IN_SESSION_ASSESSMENT_SUGGESTIONS
]

export const POST_SESSION_WORKSHEET_SUGGESTIONS = [
  {
    worksheetName: 'Reversing Anxiety Worksheet',
    rationale:
      `This worksheet is designed to help the client identify and confront their sources of anxiety by encouraging them to challenge anxious thoughts and engage in exposure to feared situations in a structured and supportive manner. By actively identifying specific triggers and formulating coping strategies, the worksheet promotes cognitive restructuring and gradual exposure, which are essential components in combating anxiety.`,
    checkInId: 'demo-check-in-id-3',
    contentSuggestionId: 'demo-content-suggestion-id-3',
    feedback: {}
  },
  ...IN_SESSION_WORKSHEET_SUGGESTIONS
]